// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2i5u6","tabsBox":"styles_tabsBox__2pTdn","createButton":"styles_createButton__2IrjF"};